import SimplePage from "@/components/layout/SimplePage";

export default function AdultEducation() {
  return (
    <SimplePage
      title="Adult Education"
      eyebrow="Lifelong Learning"
      subtitle="Hebrew, Torah, prayer, and Jewish life - taught with warmth and rigor for adult learners."
      path="/education/adult"
      ctaLabel="Enroll or learn more"
    >
      <p>
        At TIOB, Jewish learning never stops. Whether you're picking up your
        first Hebrew letter or returning to study after decades, you'll find a
        class that meets you where you are.
      </p>

      <h2>Hebrew 101 - Beginning Biblical Hebrew</h2>
      <p>
        Rabbi Fanwick's own curriculum - published as a book of the same name -
        teaches adult learners to read Biblical Hebrew without the extraneous
        information that bogs down most programs. By the end of the course you
        will be reading Hebrew with confidence.
      </p>

      <h2>Hebrew 102 - Beginning Hebrew Prayer</h2>
      <p>
        The natural follow-up to Hebrew 101: a deep dive into the language and
        meaning of our Shabbat liturgy. You'll come away both reading more
        fluently and understanding what we say at services.
      </p>

      <h2>Torah Study</h2>
      <p>
        Every Saturday morning at 9:30 AM, an open conversation about the weekly
        parashah with Rabbi Fanwick. No preparation required - just curiosity.
        Drop in any week. Coffee and light bites often make an appearance.
      </p>

      <h2>Guest Speakers & Specials</h2>
      <p>
        Throughout the year we host visiting scholars, authors, and community
        leaders for lectures and discussions. Recent and upcoming topics include
        Jewish music, Israeli politics, Torah-and-modernity dialogues, and
        more.
      </p>

      <p className="text-sm text-[var(--muted)] italic">
        Most adult-education classes are open to non-members at no charge or for
        a modest fee. Contact the office to register for the next session.
      </p>
    </SimplePage>
  );
}
